import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { advisorOptions } from '../../data/advisor';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
import { getProduct } from '../../utils/products';
export function BatteryAdvisor() {
  const {
    addItem
  } = useCart();
  const [selected, setSelected] = useState<string>(advisorOptions[0].id);
  const option = advisorOptions.find(o => o.id === selected)!;
  const match = getProduct(option.productId)!;
  const isSystem = match.template === 'system';
  return <section id="advisor" aria-labelledby="advisor-heading" className="mx-auto max-w-7xl scroll-mt-40 px-4 py-12 sm:px-6 lg:px-8 lg:py-16" data-id="element-70" data-mp="3gepd78czri56">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-center lg:gap-12" data-id="element-71" data-mp="31iznp08lkmvp">
        <div className="lg:col-span-4" data-id="element-72" data-mp="36h15lhuaeg5l">
          <h2 id="advisor-heading" className="text-2xl font-bold tracking-tight text-ink sm:text-[28px]" data-id="element-73" data-mp="36fzsz8xmhllr">
            Welke batterij past bij jou?
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-74" data-mp="t7xjeuriiozd">
            Vertel ons wat je van stroom wilt voorzien en wij wijzen je het juiste systeem aan. Liever even overleggen? Onze
            technici staan binnen een paar minuten voor je klaar.
          </p>
          <a href="tel:+31851234567" className="mt-4 inline-block text-sm font-semibold text-ink underline underline-offset-4" data-id="element-75" data-mp="ffho6g4urv90">
            Bel 085 123 4567
          </a>
        </div>

        <div className="grid gap-4 lg:col-span-8 lg:grid-cols-2" data-id="element-76" data-mp="aetqjbm4cg5t">
          <fieldset data-id="element-77" data-mp="o9m9kk17weh5">
            <legend className="mb-3 text-sm font-semibold text-ink" data-id="element-78" data-mp="oa5pxwb7yut2">Wat wil je van stroom voorzien?</legend>
            <div className="space-y-2.5" data-id="element-79" data-mp="jfi5c8jc6kjr">
              {advisorOptions.map(o => {
              const isActive = o.id === selected;
              return <label key={o.id} className={`flex cursor-pointer items-center gap-3 rounded-xl border bg-white p-4 transition-colors duration-150 ${isActive ? 'border-ink' : 'border-line hover:border-ink/30'}`} data-id="element-80" data-mp="3nv1byzmr8lgo">
                    <input type="radio" name="advisor" value={o.id} checked={isActive} onChange={() => setSelected(o.id)} className="sr-only" data-id="element-81" data-mp="20mt3v5d2wy88" />
                    <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ${isActive ? 'border-ink bg-ink' : 'border-ink/25'}`} aria-hidden="true" data-id="element-82" data-mp="17wubp13l8kzc">
                      {isActive && <CheckIcon className="h-3 w-3 text-volt" strokeWidth={3} data-id="element-83" data-mp="1hwl858bpla22" />}
                    </span>
                    <span data-id="element-84" data-mp="2t9dxkch11mey">
                      <span className="block text-sm font-semibold text-ink" data-id="element-85" data-mp="2ta6uklq6oxjw">{o.label}</span>
                      <span className="block text-xs text-muted" data-id="element-86" data-mp="2y7yw87gmry1a">{o.description}</span>
                    </span>
                  </label>;
            })}
            </div>
          </fieldset>

          <div className="flex flex-col rounded-xl bg-ink p-5 text-white" aria-live="polite" data-id="element-87" data-mp="hlsa3fnu753m">
            <p className="text-xs font-semibold text-volt" data-id="element-88" data-mp="cujzigartdov">Ons advies</p>
            <AnimatePresence mode="wait" data-id="element-89" data-mp="7w8o414tuv4j">
              <motion.div key={match.id} initial={{
              opacity: 0,
              y: 6
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.18,
              ease: [0.23, 1, 0.32, 1]
            }} className="mt-3 flex gap-4" data-id="element-90" data-mp="7v7apq0c9wjn">
                <img src={match.image} alt="" className="h-24 w-24 shrink-0 rounded-lg bg-surface object-cover" data-id="element-91" data-mp="3q3y4nwkt26sg" />
                <div className="min-w-0" data-id="element-92" data-mp="3l53pd4m1r0d3">
                  <h3 className="text-base font-semibold leading-snug" data-id="element-93" data-mp="1o9foav34svj5">
                    <Link to={`/product/${match.id}`} className="hover:underline" data-id="element-94" data-mp="1jbnmn9copv1r">
                      {match.name}
                    </Link>
                  </h3>
                  <p className="mt-1 text-xs text-white/60" data-id="element-95" data-mp="gvvekc656ah8">{match.specs.join(' · ')}</p>
                  <p className="mt-2 text-xl font-bold tracking-tight" data-id="element-96" data-mp="kys2miegaysk">
                    {isSystem && <span className="mr-1 text-xs font-medium text-white/60" data-id="element-97" data-mp="6z0kq6ktcy9a">vanaf</span>}
                    {formatPrice(match.price)}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
            {isSystem ? <Link to={`/product/${match.id}`} className="mt-auto flex h-11 w-full items-center justify-center rounded-lg bg-volt pt-0 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-volt-hover" data-id="element-98" data-mp="218s1acch841">
                Stel je systeem samen
              </Link> : <button type="button" onClick={() => addItem(match)} className="mt-auto h-11 w-full rounded-lg bg-volt text-sm font-semibold text-ink transition-colors duration-150 hover:bg-volt-hover" data-id="element-99" data-mp="3ah27rmyuqfk1">
                In winkelwagen
              </button>}
          </div>
        </div>
      </div>
    </section>;
}